module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-07.4b01913c.jpg";